import { Target, TrendingUp } from "lucide-react";
import { brl, pct } from "@/lib/format";
import { Card } from "@/components/kit";

function Progress({ value, max, testid }) {
  const p = max ? Math.min(100, (value / max) * 100) : 0;
  const done = value >= max;
  return (
    <div className="flex flex-col gap-1" data-testid={testid}>
      <div className="h-2 rounded-full overflow-hidden" style={{ background: "var(--surface-alt)" }}>
        <div className="h-full rounded-full" style={{ width: `${p}%`, background: done ? "var(--success, #2f7d4f)" : "var(--brand)", transition: "width .4s" }} />
      </div>
      <span className="caption tnum">{done ? "Atingido" : `Faltam ${brl(max - value)} em vendas`} · {pct(p, 0)}</span>
    </div>
  );
}

function Block({ icon: Icon, title, value, daily, revenue, testid, children }) {
  return (
    <div className="flex-1 min-w-[220px] flex flex-col gap-2" data-testid={testid}>
      <span className="caption flex items-center gap-1.5"><Icon size={14} /> {title}</span>
      {value === null ? <span className="caption">Não alcançável com a margem atual · revise custos ou preços</span> : (
        <>
          <span className="text-xl font-bold tnum" data-testid={`${testid}-value`}>{brl(value)}</span>
          <span className="caption tnum">≈ {brl(daily)} por dia</span>
          <Progress value={revenue} max={value} testid={`${testid}-progress`} />
        </>
      )}
      {children}
    </div>
  );
}

export function BreakEvenCard({ b, revenue }) {
  const goalLabel = b.goal_type === "valor" ? `lucro de ${brl(b.goal_value)}` : `lucro de ${pct(b.goal_value)} do faturamento`;
  return (
    <Card className="flex flex-col gap-4" data-testid="dre-breakeven-card">
      <div>
        <div className="h3">Ponto de equilíbrio</div>
        <div className="caption">Custos fixos do mês {brl(b.fixed_costs)} · cada R$ 100 vendidos deixam {brl(b.margin_pct)} depois de impostos, taxas e CMV{b.cmv_from_target ? " (CMV pela meta, sem conferências no mês)" : ""}.</div>
      </div>
      <div className="flex flex-wrap gap-6">
        <Block icon={TrendingUp} title="Vender para não ter prejuízo" value={b.breakeven} daily={b.breakeven_daily} revenue={revenue} testid="dre-breakeven" />
        {b.goal_value ? (
          <Block icon={Target} title={`Vender para bater a meta (${goalLabel})`} value={b.goal_revenue} daily={b.goal_revenue_daily} revenue={revenue} testid="dre-goal-revenue" />
        ) : <p className="caption flex-1 min-w-[220px] self-center" data-testid="dre-goal-empty">Defina uma meta de lucro em "Impostos e metas" para ver quanto precisa vender para alcançá-la.</p>}
      </div>
    </Card>
  );
}

export function GoalBadge({ b, profit }) {
  if (!b.goal_value) return null;
  const ok = b.goal_reached;
  return (
    <span className="caption tnum font-semibold" style={{ color: ok ? "var(--success, #2f7d4f)" : "var(--danger)" }} data-testid="dre-goal-status">
      {ok ? "Acima" : "Abaixo"} da meta ({brl(b.goal_profit)}) · {b.goal_gap >= 0 ? "+" : "−"}{brl(Math.abs(b.goal_gap))}
    </span>
  );
}
